/**
 * Common form handling functionality for Levain Bakery forms
 */

/**
 * Initialize form handling with the provided configuration
 * @param {Object} config - Configuration object
 * @param {string} config.formId - ID of the form element
 * @param {string} config.endpoint - API endpoint for form submission
 * @param {string} config.successModalClass - CSS selector for the success modal element
 */
function initFormHandling(config) {
  const form = document.getElementById(config.formId);
  
  if (!form) {
    console.error(`Form with ID "${config.formId}" not found`);
    return;
  }
  
  // Form submission with validation
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (checkRequiredInputs(config.formId)) {
      sendPOST(config);
    }
  });
  
  // Add validation for required fields
  let requiredInputs = form.querySelectorAll("[required]");
  requiredInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (input.value && input.parentElement.querySelector('.form-error')) {
        input.parentElement.classList.remove('form-control--error');
        input.parentElement.querySelector('.form-error').remove();
      }
    });
  });
}

/**
 * Trigger reCAPTCHA verification
 * @param {string} formId - ID of the form element
 */
function getRecaptcha() {
  // Show loading state on the submit button
  const clickedBtn = event.currentTarget;
  if (clickedBtn) {
    clickedBtn.classList.add('loading');
    const spinner = clickedBtn.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }
    clickedBtn.disabled = true;
  }
  
  grecaptcha.ready(function() {
    grecaptcha.execute('6LfyA6kZAAAAAG7cWto1BsvjqeVUNfkKHcYp4_-_', { action: 'contact' }).then(function(token) {
      var recaptchaResponse = document.getElementById('recaptchaResponse');
      recaptchaResponse.value = token;
      
      const formId = recaptchaResponse.closest('form').id;
      if (checkRequiredInputs(formId)) {
        // Find the config for this form
        const formConfig = window.formConfigs.find(config => config.formId === formId);
        if (formConfig) {
          sendPOST(formConfig);
        }
      } else {
        // Remove loading state if validation fails
        if (clickedBtn) {
          clickedBtn.classList.remove('loading');
          clickedBtn.disabled = false;
          const spinner = clickedBtn.querySelector('.loading__spinner');
          if (spinner) {
            spinner.classList.add('hidden');
          }
        }
      }
    }).catch(function(error) {
      console.error("reCAPTCHA error:", error);
      // Remove loading state
      if (clickedBtn) {
        clickedBtn.classList.remove('loading');
          clickedBtn.disabled = false;
          const spinner = clickedBtn.querySelector('.loading__spinner');
          if (spinner) {
            spinner.classList.add('hidden');
          }
      }
      alert("There was an error verifying your submission. Please try again later.");
    });
  });
}

/**
 * Check if all required inputs have values
 * @param {string} formId - ID of the form element
 * @returns {boolean} - True if all required fields are valid
 */
function checkRequiredInputs(formId) {
  let requiredInputs = document.getElementById(formId).querySelectorAll("[required]");
  let firstError = false;
  requiredInputs.forEach(function(input) {
    if (input.value == '') {
      if(input.parentElement.querySelector('.form-error') === null){
        var errorMsg = document.createElement('div');
        errorMsg.className = 'form-error';
        errorMsg.innerHTML = 'required field';
        input.parentElement.classList.add('form-control--error');
        input.parentElement.appendChild(errorMsg);
      }
      if (!firstError) {
        firstError = true;
        let pos = input.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({
          behavior: 'smooth',
          top: pos
        });
      }
    }
  });
  
  return !firstError;
}

/**
 * Send form data to the specified endpoint
 * @param {Object} config - Form configuration object
 */
function sendPOST(config) {
  const form = document.getElementById(config.formId);
  const formData = new FormData(form);
  
  // Show loading state on the submit button
  const submitBtn = form.querySelector('#spanBtn');
  if (submitBtn) {
    submitBtn.classList.add('loading');
  }
  
  fetch(config.endpoint, { method: "POST", body: formData })
    .then((response) => {
      console.log(response);
      // Remove loading state
      if (submitBtn) {
        submitBtn.classList.remove('loading');
      }
      
      if(response.ok){
        // Show success message
        document.querySelector(config.successModalClass).style.display = "flex";
      } else {
        // Show error message
        alert("There was an error submitting your form. Please try again later.");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      // Remove loading state
      if (submitBtn) {
        submitBtn.classList.remove('loading');
      }
      alert("There was an error submitting your form. Please try again later.");
    });
}

/**
 * Handle form section scrolling and update active step indicators
 * Updates the active step in the sidebar based on which fieldset is currently visible
 */
function handleFormScroll() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Get the section number from the fieldset's data-number attribute
        const sectionNumber = entry.target.dataset.number;
        
        // Remove active class from all steps
        document.querySelectorAll('.corporate-form__sidesteps > div').forEach(step => {
          step.classList.remove('active');
        });
        
        // Add active class to current step
        document.querySelector(`.corporate-form__sidesteps > div[data-number="${sectionNumber}"]`).classList.add('active');
      }
    });
  }, {
    // Adjust these options as needed
    threshold: 0.3,
    rootMargin: '-100px 0px'
  });

  // Observe all fieldsets
  document.querySelectorAll('fieldset').forEach(fieldset => {
    observer.observe(fieldset);
  });
}

// Store form configurations globally
window.formConfigs = [];

// Add a form configuration
function addFormConfig(config) {
  window.formConfigs.push(config);
  initFormHandling(config);
} 